<template>
	<Dialog
	v-model:show="isShow"
	:show-confirm-button="false"
	:show-cancel-button="false"
	className="recheck-popup"
	:width="360"
	>
		<div class="dialog-content">
			<div>
				<div class="dialog-header">
					<img src="@/assets/wordTest/l1.png" alt="">
					重新测验
					<img src="@/assets/wordTest/r1.png" alt="">
				</div>
				<div class="content">
					重新测验将<span>清零当前所有数据,</span><br>请确认是否继续？
				</div>
				<div class="dialog-footer">
					<div class="btn" @click="isShow = false">取消</div>
					<div class="btn btn-confirm" @click="confirmRecheck">确认</div>
				</div>
			</div>
			<img @click="isShow = false" class="close-btn" src="@/assets/wordTest/close.png" alt="">
		</div>
	</Dialog>
</template>
<script setup>
import { Dialog } from 'vant';
import { ref,defineExpose,defineEmits } from 'vue'
import {recheckReport} from '@/api/quick'
const emit = defineEmits(['success'])
const isShow = ref(false)
const bookInfoData = ref({})
function show(bookInfo) {
	console.log('bookInfo:', bookInfo)
	bookInfoData.value = bookInfo
	isShow.value = true
}
const btnLoading = ref(false)
async function confirmRecheck() {
  if (btnLoading.value) return // 防止重复点击
  btnLoading.value = true
  try {
    const res = await recheckReport(
			{
				bookId: bookInfoData.value.bookId,
				frameworkId: bookInfoData.value.frameworkId
			}
		)
    if (res.code === 200) {
      isShow.value = false
      // 触发父级刷新或提示
      emit('success')
    }
  } catch (error) {
    console.error('重新测验失败:', error)
  } finally {
    btnLoading.value = false
  }
}
defineExpose({
	show
})
</script>
<style scoped lang="scss">
.dialog-content {
	position: relative;
	background-color:#fff;
	border-radius: 30px;
		overflow: hidden;
	>div{
		background-color: rgba(255,255,255,0.2);
		padding:16px;
	}
	.content{
		font-size: 15px;
		color: #666666;
		text-align: center;
		margin: 20px 0;
		span{
			color: #A07DFF;
		}
	}
	.dialog-footer{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 15px;
		color: #A7A7A7;
		.btn{
			width: 135px;
			height: 40px;
			border-radius: 21px;
			border: 1px solid #C3C6CD;
			text-align: center;
			line-height: 40px;
			&:first-child{
				margin-right: 20px;
			}
			&-confirm{
				background: linear-gradient( 90deg, #BBA3FE 0%, #A07DFF 100%);
				color: #fff;
			}
		}
	}
	.close-btn{
		position: absolute;
		top: 13px;
		right: 16px;
		width: 20px;
		height: 20px;
	}
	>div{
		background: rgba(255,255,255,0.2);
	}
}
.dialog-header {
	font-weight: bold;
	font-size: 18px;
	color: #333333;
	text-align: center;	
	img{
		width: 15px;
		height: 14px;
	}
}
</style>
<!-- 新增非 scoped 样式，专门覆盖 Dialog 圆角 -->
<style lang="scss">
// 针对 Dialog 内容容器设置圆角（Vant4 核心类名）
.van-dialog {
  border-radius: 30px !important; // !important 确保覆盖 Vant 默认样式
	background:rgba(255,255,255,0.2) !important;
	padding: 6px;
}
</style>
